import { inject, InjectionToken, PLATFORM_ID, REQUEST } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

import { FirebaseApp, FirebaseServerApp, initializeApp, initializeServerApp } from 'firebase/app';

import { FIREBASE_OPTIONS } from './firebase-options.token';

const firebaseAppFactory = () => {
  const options = inject(FIREBASE_OPTIONS);
  const platformId = inject(PLATFORM_ID);
  const request = inject(REQUEST);

  const authIdToken = request?.headers.get('Authorization')?.match(/^Bearer\s+(.+)$/)?.[1];

  if (isPlatformBrowser(platformId)) {
    return initializeApp(options);
  } else {
    return initializeServerApp(options, { authIdToken, releaseOnDeref: request || undefined });
  }
}

export const FIREBASE_APP = new InjectionToken<FirebaseApp | FirebaseServerApp>('Firebase App', { factory: firebaseAppFactory, providedIn: 'root' });
